import script from "./ListWPOPur.vue?vue&type=script&setup=true&lang=js"
export * from "./ListWPOPur.vue?vue&type=script&setup=true&lang=js"

import "./ListWPOPur.vue?vue&type=style&index=0&id=57147b1a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57147b1a"]])

export default __exports__